import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import AccountDeletion from "./pages/AccountDeletion";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Statistics from "./pages/dashboard/Statistics";
import Definitions from "./pages/dashboard/Definitions";
import Settings from "./pages/dashboard/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import DemoQR from "./pages/DemoQR";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="definitions" element={<Definitions />} />
          <Route path="settings" element={<Settings />} />
          <Route index element={<Navigate to="/dashboard/dashboard" replace />} />
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        {/* Eski Türkçe URL'lerden yönlendirme */}
        <Route path="/gizlilik-sozlesmesi" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/kullanim-kosullari" element={<Navigate to="/terms-of-use" replace />} />
        <Route path="/cerez-politikasi" element={<Navigate to="/cookie-policy" replace />} />
        <Route path="/demo-qr" element={<DemoQR />} />
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
